var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4246_30247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7492 10.5004C18.6505 10.501 18.5526 10.4821 18.4612 10.4448C18.3699 10.4074 18.2867 10.3525 18.2167 10.2829L11.9992 4.05794L5.78166 10.2829C5.64043 10.4242 5.44889 10.5035 5.24916 10.5035C5.04944 10.5035 4.85789 10.4242 4.71666 10.2829C4.57543 10.1417 4.49609 9.95017 4.49609 9.75044C4.49609 9.55072 4.57543 9.35917 4.71666 9.21794L11.4667 2.46794C11.5364 2.39765 11.6193 2.34185 11.7107 2.30377C11.8021 2.2657 11.9002 2.24609 11.9992 2.24609C12.0982 2.24609 12.1962 2.2657 12.2876 2.30377C12.379 2.34185 12.4619 2.39765 12.5317 2.46794L19.2817 9.21794C19.352 9.28766 19.4078 9.37062 19.4458 9.46201C19.4839 9.5534 19.5035 9.65143 19.5035 9.75044C19.5035 9.84945 19.4839 9.94748 19.4458 10.0389C19.4078 10.1303 19.352 10.2132 19.2817 10.2829C19.2116 10.3525 19.1285 10.4074 19.0371 10.4448C18.9457 10.4821 18.8479 10.501 18.7492 10.5004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75C11.8011 21.75 11.6103 21.671 11.4697 21.5303C11.329 21.3897 11.25 21.1989 11.25 21V3C11.25 2.80109 11.329 2.61032 11.4697 2.46967C11.6103 2.32902 11.8011 2.25 12 2.25C12.1989 2.25 12.3897 2.32902 12.5303 2.46967C12.671 2.61032 12.75 2.80109 12.75 3V21C12.75 21.1989 12.671 21.3897 12.5303 21.5303C12.3897 21.671 12.1989 21.75 12 21.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4246_30247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.90fdfb301a31b39cc377b4db1bf4cc04.svg";
export { ForwardRef as ReactComponent };